<template>
  <div>
    <br />
    <br />
    <br />
    <br />
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <edit-profile-form  :mode="mode" :id="currentUserId" :backfilter="currentFilter"></edit-profile-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import { GetUser, Update, nophoto } from "../../services/user";

import store from "../../store";
export default {
  props: {
    id: String,
    filter: String
  },
  computed: {
    mode() {
      return this.currentUserId ? "Edit" : "Create";
    },
    cardVisible() {
      return this.id === this.$store.state.user.id;
    },
  },
  data() {
    return {
      currentUserId: this.id,
      currentFilter: this.filter
    };
  },
  components: {
    EditProfileForm
  },
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}
</style>
